module.exports = __webpack_public_path__ + "static/postre-2-61f1082aa4cc9ab0963ccd9e03d85775.jpg";